






























































import {Vue, Component, PropSync, Watch} from 'vue-property-decorator';
import {WebPushType} from "@/store/push/application/types";
import proxySettingsForm from "@/pages/Pages/Push/proxySettingsForm.vue";
import { InputWings } from "wings-ui-components";

@Component({components: {proxySettingsForm, InputWings}})
export default class WebPushSettings extends Vue {
  @PropSync('webPushOptions') webPush!: WebPushType;
  private isProxySettings: boolean = false;

  created() {
    if(this.webPush.proxy_settings_name) this.isProxySettings = true;
  }

  @Watch('isProxySettings')
  onChangeProxy(newValue: boolean) {
    if (!newValue) this.webPush.proxy_settings_id = undefined;
  }
}
